// Default site content — used when no override exists in the DB.
// The admin panel writes overrides to /api/site; the SiteProvider merges them
// over these defaults so the storefront always renders.

export const siteDefaults = {
  hero: {
    badge_text: "Veteran-Founded · Woman-Owned",
    overline: "Volume 01 · Renewal",
    title_line_1: "A new",
    title_em: "beginning",
    title_line_3: "in motion.",
    subtitle:
      "Performance wear and beauty rituals for the body that carries you. Christ-centered. Movement-made. Softly relentless.",
    cta_primary: "Shop the drop",
    cta_primary_href: "/shop",
    cta_secondary: "Our story",
    cta_secondary_href: "/about",
    image:
      "https://images.pexels.com/photos/4379085/pexels-photo-4379085.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1800",
  },
  marquee: {
    primary: "NEW BEGINNING",
    secondary: "Christ-Centered",
  },
  categories: {
    overline: "Two rituals · one collective",
    heading_line_1: "Shop the",
    heading_em: "categories",
    heading_line_3: ".",
    gym: {
      overline: "01 — Performance",
      title: "Performance Wear",
      subtitle: "Squat-proof, sculpt-forward, built to hold form under grace.",
      cta_label: "Shop performance",
      image:
        "https://images.pexels.com/photos/36917078/pexels-photo-36917078.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=800",
    },
    beauty: {
      overline: "02 — Renewal",
      title: "Renewal Beauty",
      subtitle:
        "Botanical oils and quiet rituals for the skin that woke up with hope.",
      cta_label: "Shop beauty",
      image:
        "https://images.pexels.com/photos/8101512/pexels-photo-8101512.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=800",
    },
  },
  featured: {
    overline: "The drop",
    heading_line_1: "Made",
    heading_em: "to move",
    heading_line_3: ".",
  },
  brand_story: {
    overline: "The Meaning",
    heading_line_1: "Founded by a",
    heading_em: "24-year-old female veteran",
    heading_line_3: ".",
    body:
      "Jenova is a Christ-centered collective for young women and veterans who are stepping into their next chapter. Every piece is a small offering. Every purchase funds the platform we're building for those beginning again.",
    cta_label: "Read our full story",
    image_1:
      "https://images.unsplash.com/photo-1516915871149-2d59d11201fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxtYW4lMjBneW0lMjBhcHBhcmVsJTIwc3VubGlnaHR8ZW58MHx8fHwxNzgzMTQzNTU4fDA&ixlib=rb-4.1.0&q=85",
    image_2:
      "https://images.unsplash.com/photo-1523358959537-cc0e4103d0b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxzdW5saWdodCUyMGFyY2hpdGVjdHVyZSUyMHJlbmV3YWx8ZW58MHx8fHwxNzgzMTQzNTQzfDA&ixlib=rb-4.1.0&q=85",
    image_3:
      "https://images.unsplash.com/photo-1490351267196-b7a67e26e41b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxzdW5saWdodCUyMGFyY2hpdGVjdHVyZSUyMHJlbmV3YWx8ZW58MHx8fHwxNzgzMTQzNTQzfDA&ixlib=rb-4.1.0&q=85",
  },
  about: {
    overline: "Our Story",
    heading_line_1: "A collective for",
    heading_em: "new beginnings",
    heading_line_3: ".",
    section_1: {
      overline: "01 — The Founder",
      title_line_1: "24. A woman.",
      title_em: "A veteran.",
      title_line_3: "",
      body:
        "I served. I came home. And I started building the collective I wished existed on the other side. Jenova is what happens when you decide the uniform doesn't get the last word — when you choose renewal, when you choose to begin again. This brand is Christ-centered because that's what carried me here.",
      image:
        "https://images.unsplash.com/photo-1523358959537-cc0e4103d0b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxzdW5saWdodCUyMGFyY2hpdGVjdHVyZSUyMHJlbmV3YWx8ZW58MHx8fHwxNzgzMTQzNTQzfDA&ixlib=rb-4.1.0&q=85",
    },
    section_2: {
      overline: "02 — The Mission",
      title_line_1: "For young women.",
      title_em: "For veterans.",
      title_line_3: "For every next chapter.",
      body:
        "Jenova is more than a clothing brand — it's a platform. A place to lift up young women stepping into who they were made to be, and veterans stepping into what comes next. Every piece you wear, every ritual you keep, funds the community we're building. This is streetwear for the sanctuary. This is the collective for the ones beginning again.",
      quote_text:
        "Behold, I am doing a new thing; now it springs forth, do you not perceive it?",
      quote_source: "— Isaiah 43:19",
      image:
        "https://images.unsplash.com/photo-1490351267196-b7a67e26e41b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxzdW5saWdodCUyMGFyY2hpdGVjdHVyZSUyMHJlbmV3YWx8ZW58MHx8fHwxNzgzMTQzNTQzfDA&ixlib=rb-4.1.0&q=85",
    },
    cta: {
      overline: "03 — Join Us",
      title_line_1: "Begin",
      title_em: "again",
      title_line_3: ".",
      body:
        "The collective is small. The rituals are quiet. The mission is loud. Made for young women and veterans — made for anyone stepping into a new beginning.",
      cta_label: "Enter the Collection",
    },
  },
  footer: {
    newsletter_title_line_1: "Enter your",
    newsletter_title_em: "new beginning",
    newsletter_title_line_3: ".",
    newsletter_body:
      "Join the collective for early product releases, devotionals for movement, and 10% off your first order.",
    tagline_quote: '"Behold, I am doing a new thing." — Isaiah 43:19',
  },
  instagram: {
    handle: "jenovacollective.co",
    overline: "Follow along",
    heading_line_1: "Live from the",
    heading_em: "collective",
    heading_line_3: ".",
    subtitle:
      "New drops, morning devotionals, and behind-the-scenes of the brand.",
    cta_label: "Follow @jenovacollective.co",
    posts: [],
  },
  launch_mode: "prelaunch", // "prelaunch" | "live"
  prelaunch: {
    overline: "Coming soon",
    title_line_1: "A",
    title_em: "new beginning",
    title_line_3: "is on its way.",
    subtitle:
      "Born from faith. Built from resilience. Created for your becoming. Performance wear and lifestyle pieces for women stepping boldly into their next chapter.",
    cta_label: "Reserve your founding spot",
    cta_href: "/founding",
  },
};

// Deep-merge overrides over defaults (used by SiteProvider).
export function mergeSite(overrides) {
  const merge = (d, o) => {
    if (!o || typeof o !== "object") return d;
    if (Array.isArray(d)) return o;
    const out = { ...d };
    for (const k of Object.keys(o)) {
      if (o[k] === undefined || o[k] === null || o[k] === "") continue;
      if (typeof d[k] === "object" && d[k] !== null && !Array.isArray(d[k])) {
        out[k] = merge(d[k], o[k]);
      } else {
        out[k] = o[k];
      }
    }
    return out;
  };
  return merge(siteDefaults, overrides || {});
}

// Resolve an image URL — if it's a relative /api/files/... path, prepend the backend URL.
export function resolveImage(url) {
  if (!url) return "";
  if (url.startsWith("/api/")) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  return url;
}
